import ApiService from "@Src/services/ApiService";
import { TOPIC_ANALYTICS_API_ROUTES } from "./analytics.api.constant";

export async function getTopicAnalysis(params?: any): Promise<any> {
    return await ApiService.fetchData({
        url: TOPIC_ANALYTICS_API_ROUTES.TOPIC_ANALYSIS,
        method: "get",
        params: params
    });
}
